export const subscribeMobileECG = {
  data: () => ({
    stack: {},
    canSubscribe: false,
    isThrottled: false,
    ms: 700
  }),
  computed: {
    isSocketAuth() {
      return this.$store.getters.IS_SOCKET_AUTH
    }
  },
  watch: {
    canSubscribe() {
      if (this.canSubscribe && this.isSocketAuth) {
        this.subscribe()
      } else if (!this.canSubscribe) {
        this.unsubscribe()
      }
    }
  },
  created() {
    if (this.canSubscribe && this.isSocketAuth) {
      this.subscribe()
    }
  },
  beforeDestroy() {
    this.unsubscribe()
  },
  methods: {
    subscribe() {
      this.sockets.subscribe('api/mobile-ecg created', event => {
        if (+this.trainingId === +event.train_id && !this.loaded) {
          this.changeDataByECG(event)
        }
      })
    },
    unsubscribe() {
      this.sockets.unsubscribe('api/mobile-ecg created')
    }
  }
}
